import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpResponse} from '@angular/common/http';
import {BaseRestService} from '../BaseRestService';

@Injectable()
export class FileRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('file');
  }

  getImage(id: string): Observable<ImageData> {
    return this.http.get<ImageData>(this.getEndpoint(['image', id]));
  }

  getFile(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.getEndpoint([String(id)]), { observe: 'response', responseType: 'blob' });
  }

}
